export enum PermissionName {
  // External permissions
  ADMINISTER_TRAINING = 'ADMINISTER_TRAINING',
  ADMIN_VIEW = 'ADMIN_VIEW',
  CASE_MANAGEMENT = 'CASE_MANAGEMENT',
  COMPANY_ONBOARDING = 'COMPANY_ONBOARDING',
  MANAGE_BILLING = 'MANAGE_BILLING',
  MANAGE_BRANDING = 'MANAGE_BRANDING',
  MANAGE_CASE_PERMISSIONS = 'MANAGE_CASE_PERMISSIONS',
  MANAGE_COMPANY_INFO = 'MANAGE_COMPANY_INFO',
  MANAGE_COMPANY_POLICIES = 'MANAGE_COMPANY_POLICIES',
  MANAGE_COURSE_PERMISSIONS = 'MANAGE_COURSE_PERMISSIONS',
  MANAGE_INTEGRATIONS = 'MANAGE_INTEGRATIONS',
  MANAGE_NOTIFICATION_SETTINGS = 'MANAGE_NOTIFICATION_SETTINGS',
  MANAGE_TEAM_LIST = 'MANAGE_TEAM_LIST',
  MANAGE_USER_ROLES = 'MANAGE_USER_ROLES',
  VIEW_ADMINISTRATORS = 'VIEW_ADMINISTRATORS',
  VIEW_COMPANY_SETTINGS = 'VIEW_COMPANY_SETTINGS',

  // Internal permissions
  INTERNAL_CL_CALENDAR = 'INTERNAL_CL_CALENDAR',
  INTERNAL_COMPANIES = 'INTERNAL_COMPANIES',
  INTERNAL_COMPANY_COURSES = 'INTERNAL_COMPANY_COURSES',
  INTERNAL_COMPANY_SETTINGS = 'INTERNAL_COMPANY_SETTINGS',
  INTERNAL_COMPANY_USERS = 'INTERNAL_COMPANY_USERS',
  INTERNAL_COURSES = 'INTERNAL_COURSES',
  INTERNAL_DEV = 'INTERNAL_DEV',
  INTERNAL_INTEGRATIONS = 'INTERNAL_INTEGRATIONS',
  INTERNAL_PARTNERS = 'INTERNAL_PARTNERS',
  INTERNAL_PII = 'INTERNAL_PII',
  INTERNAL_PREVIEW_LINKS = 'INTERNAL_PREVIEW_LINKS',
  INTERNAL_QA = 'INTERNAL_QA',
  INTERNAL_QUESTIONS = 'INTERNAL_QUESTIONS',
  INTERNAL_SCORM_EXPORTS = 'INTERNAL_SCORM_EXPORTS',
  INTERNAL_SEARCH = 'INTERNAL_SEARCH',
  INTERNAL_SELF_SERVE_CHECKOUT = 'INTERNAL_SELF_SERVE_CHECKOUT',
  INTERNAL_STRING_VARIABLES = 'INTERNAL_STRING_VARIABLES',
  INTERNAL_SUPER = 'INTERNAL_SUPER',
  INTERNAL_TEMPLATES = 'INTERNAL_TEMPLATES',
  INTERNAL_THEMES = 'INTERNAL_THEMES',
  INTERNAL_TRANSLATE = 'INTERNAL_TRANSLATE',
  INTERNAL_USER_ROLES = 'INTERNAL_USER_ROLES',
  INTERNAL_VIEW = 'INTERNAL_VIEW',
}

export enum FeatureName {
  ANALYTICS = 'ANALYTICS',
  CASE_MANAGEMENT = 'CASE_MANAGEMENT',
  EVENTS = 'EVENTS',
  HOTLINE_AND_CASE_MANAGEMENT = 'HOTLINE_AND_CASE_MANAGEMENT',
  LMS_ESSENTIALS = 'LMS_ESSENTIALS',
  PHISHING = 'PHISHING',
  SCORM = 'SCORM',
  SCORM_ONLY = 'SCORM_ONLY',
  USERS_WITHOUT_EMAILS = 'USERS_WITHOUT_EMAILS',
  // Potentially temporary for lifelabs
  TEAM_INSIGHTS = 'TEAM_INSIGHTS',
  COMPANY_POLICIES = 'COMPANY_POLICIES',
}
